import { Box, Button, Flex, HStack, Text, Tooltip } from "@chakra-ui/react"
import { Clock, ClockAfternoon, File, Files, FileText, ProhibitInset } from "@phosphor-icons/react"

import dateFormat from "functions/dateFormat"

interface Props {
	title: string
	beginAt: Date
}

const ReadOnlyEvent = ({ title, beginAt }: Props) => {
	return (
		<Flex w="full" justifyContent="start" alignItems="center">
			<Flex justifyContent="center" alignItems="center" mr="20px">
				<Files size={36} />
			</Flex>
			<Box>
				<Box>
					<Text fontSize="md">{title}</Text>
					<Text fontSize="lg" fontWeight="bold">{dateFormat(beginAt, "dd/MM/yyyy HH:mm:ss")}</Text>
				</Box>
			</Box>
		</Flex>
	)
}

export default ReadOnlyEvent
